import React from 'react'
import { Link } from 'react-router-dom'
import ModalUI from '../../../widgets/layout/ModalUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import ButtonTinyUI from '../../../widgets/action/ButtonTinyUI'
import TestLoanCreateModalSF from './TestLoanCreateModalSF'
import TestLoanCloneCreateModalSF from './TestLoanCloneCreateModalSF'
// import './AccountList.css'

const TestAccountListUI = ({ context, onRefreshClick, accountList, accountKeyValueList, accountSubmitted, updateMode, onUpdateClick, onCancelClick,
  onCloneLoanClick,
  onDeleteClick, deleteSubmitted, onRecreateClick, recreateSubmitted, selectedAccountId,
  createLoanMode, onCreateLoanClick, onCancelCreateLoan,
  onDeleteLoanClick, deleteLoanSubmitted, selectedLoanId, deleteLoanResult, onHideDeleteLoanResult
}) =>
  <div className='su_accs'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          onRefreshClick={onRefreshClick}
        />
      }
      right={<span />}
    />

    <LRTableBodyUI>
      {
        accountList.map((account, i) =>
          <AccountRowUI key={i} context={context} account={account} selectedAccountId={selectedAccountId}
            onDeleteClick={onDeleteClick} deleteSubmitted={deleteSubmitted}
            onRecreateClick={onRecreateClick} recreateSubmitted={recreateSubmitted}
            createLoanMode={createLoanMode} onCreateLoanClick={onCreateLoanClick}
            onDeleteLoanClick={onDeleteLoanClick} deleteLoanSubmitted={deleteLoanSubmitted}
            selectedLoanId={selectedLoanId} onCloneLoanClick={onCloneLoanClick}
            //

            onUpdateClick={onUpdateClick} onCancelClick={onCancelClick} updateMode={updateMode}
            accountKeyValueList={accountKeyValueList} onRefreshClick={onRefreshClick}
          />
        )
      }
    </LRTableBodyUI>

    <TestLoanCreateModalSF context={context} createLoanMode={createLoanMode}
      onCancelCreateLoan={onCancelCreateLoan} selectedAccountId={selectedAccountId}
      onRefreshClick={onRefreshClick}
    />

    <TestLoanCloneCreateModalSF context={context} selectedLoanId={selectedLoanId} updateMode={updateMode}
      onRefreshClick={onRefreshClick} accountList={accountKeyValueList} onCancelClick={onCancelClick}
    />

    <ModalUI
      isOpen={deleteLoanResult !== null}
      // event handlers
      onRequestClose={onHideDeleteLoanResult}
    >
      <div>Deleted: {deleteLoanResult && JSON.stringify(deleteLoanResult)}</div>
    </ModalUI>
  </div>

const AccountRowUI = ({ context, account,
  onDeleteClick, deleteSubmitted, onRecreateClick, recreateSubmitted, selectedAccountId,
  createLoanMode, onCreateLoanClick, onCloneLoanClick, onRefreshClick,
  onDeleteLoanClick, deleteLoanSubmitted, selectedLoanId,
  //
  accountSubmitted, updateMode, onUpdateClick, onCancelClick,
  accountKeyValueList
}) =>
  <LRTableRowUI
    context={context} className='g_flex_top'
    left={<RowLeftUI context={context} account={account} loanList={account.loanList}
      createLoanMode={createLoanMode} onCreateLoanClick={onCreateLoanClick}
      onDeleteLoanClick={onDeleteLoanClick} deleteLoanSubmitted={deleteLoanSubmitted}
      selectedLoanId={selectedLoanId} onCloneLoanClick={onCloneLoanClick} onRefreshClick={onRefreshClick}
      //
      accountList={accountKeyValueList}
      accountSubmitted={accountSubmitted} updateMode={updateMode} onUpdateClick={onUpdateClick}
      onCancelClick={onCancelClick}
    />}
    right={<RowRightUI account={account} selectedAccountId={selectedAccountId}
      onDeleteClick={onDeleteClick} deleteSubmitted={deleteSubmitted}
      onRecreateClick={onRecreateClick} recreateSubmitted={recreateSubmitted}
    />}
  />

const RowLeftUI = ({ context, account, loanList, onCreateLoanClick,
  onDeleteLoanClick, deleteLoanSubmitted, selectedLoanId, accountList,
  updateMode, onUpdateClick, onCancelClick, onRefreshClick,
}) =>
  <div className='g_flex_v'>
    <div>
      <b>{account.accountName}</b>
    </div>
    {
      account.assignedUserName &&
      <div className='g_muted g_small'>
        Assigned to: {account.assignedUserName}
        <span className='g_muted g_m_left_100'>Recreated: {account.dateCreatedF1}</span>
      </div>
    }
    <div className='g_muted g_small'>
      <span>Primary test user: {account.ownerAccountUser && account.ownerAccountUser.email}</span>
      <span className='g_m_left_100'>Zybra company id: {account.zybraCompanyId}</span>
    </div>
    {
      loanList.map((loan, i) =>
        <div className='g_flex_h g_flex_left' key={i}>
          <Link to={`/su/loans/${loan.loanId}`}>Loan {loan.loanName ? `${loan.loanName}` : ''}</Link>
          <span className='g_m_left_50'>[{loan.status}] [{loan.subStatus}]{' '}</span>
          <SpinnerUI show={deleteLoanSubmitted && selectedLoanId === loan.loanId} reserveSpace={true} />
          <ButtonTinyUI label='Delete' rowId={loan.loanId} onClick={onDeleteLoanClick} />
          <ButtonTinyUI label='Clone' rowId={loan.loanId} onClick={onUpdateClick} className='g_m_left_50' />
        </div>
      )
    }
    <div>
      <ButtonTinyUI label='Create loan' rowId={account.accountId} onClick={onCreateLoanClick} />
    </div>
  </div>

const RowRightUI = ({ account, selectedAccountId,
  onDeleteClick, deleteSubmitted,
  onRecreateClick, recreateSubmitted
}) =>
  <div className='g_flex_h'>
    {
      !account.deletable &&
      <React.Fragment>
        <SpinnerUI show={recreateSubmitted && selectedAccountId === account.accountId} reserveSpace={true} />
        <ButtonTinyUI label='Recreate' rowId={account.accountId} onClick={onRecreateClick} />
      </React.Fragment>
    }
    {
      account.deletable &&
      <React.Fragment>
        <SpinnerUI show={deleteSubmitted && selectedAccountId === account.accountId} reserveSpace={true} />
        <ButtonTinyUI label='Delete' rowId={account.accountId} onClick={onDeleteClick} />
      </React.Fragment>
    }
  </div>

const ActionLeftUI = ({ context, onRefreshClick }) =>
  <div className='g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
  </div>

export default TestAccountListUI
